<template>
  <div class="main-content">
    <div class="h2"><strong>驗證電子郵件</strong></div>
    <div class="subtitle">
      已經有帳戶了嗎？<a href="#" @click="$store.commit('setLoginCurrentContent', 'login')">帳戶登錄</a>
    </div>
    <div class="send-bag">
      <div id="error-password" class="text-danger"></div>
      <button class="form-button bg-success" @click="sentVerificationMail">寄出驗證信</button>
    </div>
    <hr>
    <copyright-component></copyright-component>
  </div>
</template>

<script>
import CopyrightComponent from '../layouts/CopyrightComponent.vue';
import { validation } from '../mixins/validation.js';
import { axiosMixins } from '../mixins/axiosErrorMessage.js';

export default {
  mixins: [validation, axiosMixins],
  data() {
    return {
      reset_password: {
        check_sum: ''
      }
    }
  },
  methods: {
    sentVerificationMail() {
      if (!this.validateBeforeSubmit()) { return }
      const error_element = this.$el.querySelector('#error-password')
      const axios_data = {
        account: this.$store.getters.verifyAccount,
        verify_method: 'email',
      };
      axios.post(base_url + '/api/verify/request-verification', axios_data)
        .then((response) => {
          if (response.data.status === "success") {
            this.$store.commit('setVerifyAccount', '');
            this.$store.commit('setLoginCurrentContent', 'enter-token');
          } else {
            error_element.innerHTML = "驗證系統忙碌，請稍後再試";
          }
        }).catch((error) => {
          this.axiosMessage(error);
          error_element.innerHTML = "驗證系統忙碌，請稍後再試";
        });

      setTimeout(() => {
        if (error_element.innerHTML !== "") {
          error_element.innerHTML = "";
        }
      }, 3000);
    }
  },
  components: { CopyrightComponent },
}
</script>
